import { RN_EXIT_MESSAGE_TYPE } from '@/constants/native-webview-exit';

declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
    };
  }
}

export interface GameContinueExitFallbackMessages {
  readonly closeTab: string;
  readonly appBack: string;
}

export interface GameExitOptions {
  readonly exitDelayMs?: number;
}

const EXIT_DELAY_MS = 5000;

/**
 * Result-screen Continue: RN WebView postMessage, then window.close, then toast fallback.
 */
export async function gameExit(
  fallbackMessages: GameContinueExitFallbackMessages,
  showFallbackToast: (message: string) => void,
  options: GameExitOptions = {},
): Promise<void> {
  if (globalThis.window === undefined) {
    return;
  }

  const hadRnBridge = Boolean(globalThis.window.ReactNativeWebView?.postMessage);

  // 1. post message
  const bridge = globalThis.window.ReactNativeWebView;
  if (bridge?.postMessage) {
    bridge.postMessage(JSON.stringify({ type: RN_EXIT_MESSAGE_TYPE }));
  }

  // 2. toast
  const hint = hadRnBridge ? fallbackMessages.appBack : fallbackMessages.closeTab;
  showFallbackToast(hint);

  // 3. window close after a configurable fallback delay
  await new Promise<void>((resolve) => {
    globalThis.setTimeout(resolve, options.exitDelayMs ?? EXIT_DELAY_MS);
  });

  if (globalThis.document.visibilityState === 'visible') {
    globalThis.window.close();
  }
}
